// import React, { useEffect, useState } from 'react'
// import AuthNavbar from '../components/AuthNavbar/AuthNavbar'
// import { useSelector } from 'react-redux';
// import { Button, Container, Modal, Row } from 'react-bootstrap';
// import axios from 'axios';
// import CustomInput from '../components/CustomInput/CustomInput';

// function Notifications() {
//     const { currentLocal } = useSelector((state) => state.currentLocal);
//     const [show, setShow] = useState(false)
//     const [resson, setReson] = useState('')
//     const userinfo = useSelector((state) => state);
//     const [items, setItems] = useState([])
//     const [itemsEx, setItemsEx] = useState([])
//     const [selectedItem, setSelectedItem] = useState(null); // store current item


//     const handleClose = () => setShow(false)
//     const getData = async () => {

//         try {
//             const response = await axios.get('https://nanosoft.space/taarteb/public/api/admin/student-fees', {
//                 headers: {
//                     Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                 },
//             });
//             setItems(response.data.data);


//         } catch (error) {
//             console.log(error);

//         }
//         try {
//             const response = await axios.get('https://nanosoft.space/taarteb/public/api/admin/student-expenses', {
//                 headers: {
//                     Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                 },
//             });
//             setItemsEx(response.data.data);
// console.log(response.data.data);


//         } catch (error) {
//             console.log(error);

//         }
//     }
//     useEffect(() => {

//         getData()
//     }, [])
//     return (
//         <div>
//             <AuthNavbar

//             />
//             <Container>
//                 <Row>
//                     <h5>{currentLocal.home.Notifications}</h5>
//                     <div className='mt-4 border p-3 rounded'>
//                         {
//                             items.map((item) => {
//                                 console.log(item?.payment_method);

//                                 return (
//                                     <div className='d-flex align-items-center border-bottom py-3 justify-content-between'>
//                                         <Modal
//                                             aria-labelledby="contained-modal-title-vcenter"
//                                             centered

//                                             show={show} onHide={handleClose}>

//                                             <Modal.Body className='border-0'>
//                                                 <CustomInput
//                                                     placeholder={currentLocal.home.resonOfreject}
//                                                     value={resson}
//                                                     onChange={(e) => setReson(e.target.value)}

//                                                 />
//                                             </Modal.Body>
//                                             <Modal.Footer className='border-0'>
//                                                 <Button variant="secondary" onClick={handleClose}>
//                                                     {currentLocal.home.close}
//                                                 </Button>
//                                                 <Button variant="primary" onClick={async () => {
//                                                     try {
//                                                         const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-fees/${selectedItem?.id}`, {
//                                                             "payment_status": "paid",
//                                                             "status": "rejected",
//                                                             "reason": resson
//                                                         }, {
//                                                             headers: {
//                                                                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                             },
//                                                         });
//                                                         setShow(false)
//                                                         getData()

//                                                     } catch (error) {
//                                                         console.log(error);

//                                                     }
//                                                 }}>
//                                                     {currentLocal.home.send}
//                                                 </Button>
//                                             </Modal.Footer>
//                                         </Modal>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             {item?.student?.name}
//                                         </div>
//                                         <div>
//                                             {item?.payment_method == 1 ? "cash" : "visa"}
//                                         </div>

//                                         <img src={item?.receipt} style={{ width: "15%", }} />
//                                         <div>
//                                             <button className='btn btn-success mx-2'
//                                                 onClick={async () => {
//                                                     try {
//                                                         const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-fees/${selectedItem?.id}`, {
//                                                             "payment_status": "paid",
//                                                             "status": "accepted"
//                                                         }, {
//                                                             headers: {
//                                                                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                             },
//                                                         });
//                                                         getData()

//                                                     } catch (error) {
//                                                         console.log(error);

//                                                     }
//                                                 }}

//                                             >{currentLocal.home.accept}</button>
//                                             <button className='btn btn-danger'
//                                                 onClick={async () => {
//                                                     setShow(true)
//     setSelectedItem(item); // set which item is being rejected

//                                                 }}
//                                             >{currentLocal.home.reject}</button>
//                                         </div>
//                                     </div>
//                                 )
//                             })
//                         }
//                         {
//                             itemsEx.map((item) => {
//                                 console.log(item?.payment_method);

//                                 return (
//                                     <div className='d-flex align-items-center border-bottom py-3 justify-content-between'>
//                                         <Modal
//                                             aria-labelledby="contained-modal-title-vcenter"
//                                             centered

//                                             show={show} onHide={handleClose}>

//                                             <Modal.Body className='border-0'>
//                                                 <CustomInput
//                                                     placeholder={currentLocal.home.resonOfreject}
//                                                     value={resson}
//                                                     onChange={(e) => setReson(e.target.value)}

//                                                 />
//                                             </Modal.Body>
//                                             <Modal.Footer className='border-0'>
//                                                 <Button variant="secondary" onClick={handleClose}>
//                                                     {currentLocal.home.close}
//                                                 </Button>
//                                                 <Button variant="primary" onClick={async () => {
//                                                     try {
//                                                         const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-expenses/${selectedItem?.id}`, {
//                                                             "status": "rejected",
//                                                             "rejected_reason": resson
//                                                         }, {
//                                                             headers: {
//                                                                 Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                             },
//                                                         });
//                                                         setShow(false)
//                                                         getData()

//                                                     } catch (error) {
//                                                         console.log(error);

//                                                     }
//                                                 }}>
//                                                     {currentLocal.home.send}
//                                                 </Button>
//                                             </Modal.Footer>
//                                         </Modal>
//                                         <div>

//                                         </div>
//                                         <div>
//                                             {item?.student?.name}
//                                         </div>
//                                         <div>
//                                             {item?.payment_method == 1 ? "cash" : "visa"}
//                                         </div>

//                                         <img src={item?.receipt} style={{ width: "15%", }} />
//                                         <div>
//                                             <button className='btn btn-success mx-2'
//                                                 onClick={async () => {
//                                                     console.log(selectedItem?.id);

//                                                     // try {
//                                                     //     const response = await axios.post(`https://nanosoft.space/taarteb/public/api/admin/student-expenses/${selectedItem?.id}`, {
//                                                     //         "status": "accepted"
//                                                     //     }, {
//                                                     //         headers: {
//                                                     //             Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//                                                     //         },
//                                                     //     });
//                                                     //     getData()

//                                                     // } catch (error) {
//                                                     //     console.log(error);

//                                                     // }
//                                                 }}

//                                             >{currentLocal.home.accept}</button>
//                                             <button className='btn btn-danger'
//                                                 onClick={async () => {
//                                                     setShow(true)
//     setSelectedItem(item); // set which item is being rejected

//                                                 }}
//                                             >{currentLocal.home.reject}</button>
//                                         </div>
//                                     </div>
//                                 )
//                             })
//                         }
//                     </div>

//                 </Row>

//             </Container>
//         </div>
//     )
// }

// export default Notifications


import React, { useEffect, useState } from "react";
import AuthNavbar from "../components/AuthNavbar/AuthNavbar";
import { useSelector } from "react-redux";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import axios from "axios";
import CustomInput from "../components/CustomInput/CustomInput";
import CustomModel from "../components/CustomModel/CustomModel";
import { useNavigate } from "react-router-dom";

function Notifications() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state);
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [reason, setReason] = useState("");
  const [amount_paid, setAmount_paid] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [showImg, setShowImg] = useState(false);
  const [imageSrc, setImgSrc] = useState(false);


  const [modalShow, setModalShow] = useState(false);
  const [acceptState, setAcceptState] = useState(false);
  const [data, setData] = useState([])
  const [statusPending, setstatusPending] = useState(false);
  const [paymentState, setPaymentState] = useState('');


  const [items, setItems] = useState([]);
  const [itemsEx, setItemsEx] = useState([]);

  const handleClose = () => {
    setShow(false);
    setReason("");
    setSelectedItem(null);
    setSelectedType(null);
  };
// const ReadNotification=async(ids)=>{
//     try {
//       const response = await axios.post(
//         "https://nanosoft.space/taarteb/public/api/notification/read",{
//               "notifications_ids":ids

//         },
//         {
//           headers: {
//             Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
//           },
//         }
//       );

//     } catch (error) {
//       console.log(error);
//     }
// }
  const getData = async () => {
    try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/admin/student-fees",
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );
      
      setItems(response.data.data);

    } catch (error) {
      console.log(error);
    }
    try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/notification/all",
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );
      const merged = Object.values(data).flat();
const unredNot=merged.filter((item)=>item?.read_at==null)
const ids = unredNot.map(item => item.id);
// ReadNotification(ids)


      setData(response.data.data);

    } catch (error) {
      console.log(error);
    }

    try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/admin/student-expenses",
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );
      setItemsEx(response.data.data);
      setPaymentState('expenses')
    } catch (error) {
      console.log(error);
    }
  };
  // const ReadNotification = async () => {
  //   try {
  //     const response = await axios.get(
  //       "https://nanosoft.space/taarteb/public/api/admin/student-expenses",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
  //         },
  //       }
  //     );
  //     setItemsEx(response.data.data);
  //     setPaymentState('expenses')
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  useEffect(() => {
    getData();
    // ReadNotification()
  }, []);

  // ✅ Handle reject submit
  const handleReject = async () => {
    if (!selectedItem || !selectedType) return;
    try {
      if (selectedType === "fees") {
        const body = acceptState === "accept" ? {
          status: acceptState !== "accept" ? "rejected" : "accepted",


        } : {
          status: acceptState !== "accept" ? "rejected" : "accepted",
          reason: acceptState !== "accept" ? reason : "",

        }
        await axios.post(
          `https://nanosoft.space/taarteb/public/api/admin/student-fees/${selectedItem?.id}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            },
          }
        );
      } else {

        const body = acceptState === "accept" ? {
          status: acceptState !== "accept" ? "rejected" : "accepted",
          amount_paid: acceptState === "accept" ? amount_paid : 0


        } : {
          status: acceptState !== "accept" ? "rejected" : "accepted",
          rejected_reason: acceptState !== "accept" ? reason : "",

        }
        const url = `https://nanosoft.space/taarteb/public/api/admin/student-expenses/${selectedItem?.id}`
        await axios.post(

          url,
          body,
          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            },
          }
        );



      }
      handleClose();
      getData();
    } catch (error) {
      console.log(error);
      handleClose();

    }
  };

  // ✅ Component for each row
  const NotificationItem = ({ item, type }) => {

    return (
      <div className="d-flex align-items-center border-bottom py-3 justify-content-between">
        <div>{item?.student?.name}</div>
        <div>{item?.payment_method === 1 ? "cash" : "visa"}</div>
        <img src={item?.receipt} alt="receipt" style={{ width: "5%", height: "10%", borderRadius: "50%", objectFit: "contain" }} />
        <div>
          {/* Accept */}
          <button
            className="btn btn-success mx-2"
            onClick={async () => {
              setShow(true);
              setSelectedItem(item);
              setSelectedType(type);
              setAcceptState("accept")
              setPaymentState(type)
              // try {
              //   if (type === "fees") {
              //     await axios.post(
              //       `https://nanosoft.space/taarteb/public/api/admin/student-fees/${item?.id}`,
              //       {
              //         payment_status: "paid",
              //         status: "accepted",
              //       },
              //       {
              //         headers: {
              //           Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
              //         },
              //       }
              //     );
              //   } else {
              //     await axios.post(
              //       `https://nanosoft.space/taarteb/public/api/admin/student-expenses/${item?.id}`,
              //       {
              //         status: "accepted",
              //       },
              //       {
              //         headers: {
              //           Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
              //         },
              //       }
              //     );
              //   }
              //   getData();
              // } catch (error) {
              //   console.log(error);
              // }
            }}
          >
            {currentLocal.home.accept}
          </button>

          {/* Reject */}
          <button
            className="btn btn-danger"
            onClick={() => {
              setShow(true);
              setSelectedItem(item);
              setAcceptState("reject");
              setSelectedType(type);
            }}
          >
            {currentLocal.home.reject}
          </button>
        </div>
      </div>
    )
  }
    ;
  const handleShowImg = (img) => {
    setShowImg(true)
    setImgSrc(img)
  }

  return (
    <div>
      <Modal show={showImg} onHide={() => setShowImg(false)} size="lg" centered>
        <Modal.Body className="text-center">
          <img src={imageSrc} alt="full" style={{ width: "100%", height: "auto" }} />
        </Modal.Body>
        <Modal.Footer>
          <a href={imageSrc} download target="_blank" rel="noreferrer">
            <Button variant="primary">{currentLocal.home.download}</Button>
          </a>
          <Button variant="secondary" onClick={() => setImgSrc(false)}>
            {currentLocal.home.close}
          </Button>

        </Modal.Footer>
      </Modal>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Body className="border-0">
          {acceptState === "accept" ?
            paymentState == "expenses" &&
            <CustomInput
              placeholder={currentLocal.home.amount_paid}
              value={amount_paid}
              onChange={(e) => setAmount_paid(e.target.value)}
            />
            :
            <CustomInput
              placeholder={currentLocal.home.resonOfreject}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />

          }

        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="primary" onClick={handleReject}>
            {currentLocal.home.send}
          </Button>
          <Button variant="danger" onClick={handleClose}>
            {currentLocal.home.close}
          </Button>

        </Modal.Footer>
      </Modal>
      <CustomModel
        show={modalShow}
        onHide={() => setModalShow(false)}
        status={statusPending}
        acceptStatus={selectedType === "maintenance" ? "maintenances" : "purchases"}
        id={selectedItem?.id}
      />
      <AuthNavbar />
      <Container >
        <Row className="mx-3">
          <h5>{currentLocal.home.Notifications}</h5>
          <div>
            {Object.entries(data).map(([title, items]) => (
              <div key={title} style={{ marginBottom: "20px" }}>
                {title == "maintenance" && <p className="fw-bold">{currentLocal.home.Maintenance}</p>}
                {title == "purchase" && <p className="fw-bold">{currentLocal.home.Purchases}</p>}
                {title == "expense" && <p className="fw-bold">{currentLocal.home.mainexpenses}</p>}
                {/* {title == "student_fee" && <p className="fw-bold">{currentLocal.home.forms}</p>} */}
                {title == "student_expense" && <p className="fw-bold">{currentLocal.home.Academicyearexpenses}</p>}
                {title == "student_fee" && <p className="fw-bold">{currentLocal.home.registrationform}</p>}
                {title == "registration_fee" && <p className="fw-bold">{currentLocal.home.Registrationandtuitionfees}</p>}
                {items.length > 0 ? (
                  <div className="border p-3 rounded">


                    {items.map((item, index) => (
                      <Row className="mb-3 border-bottom "
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (title == "expense") {
                            navigate("/dashboard/student/Finance")
                          } else if (title == "registration_fee") {
                            navigate("/dashboard/finance")

                          } else if (title == "maintenance") {
                            navigate("/dashboard/maintenance")
                          } else if (title == "purchase") {
                            navigate("/dashboard/Purchases")
                          }else if(title == "student_expense"){
                            navigate("/dashboard/finance")

                          }
                        }}
                      >
                        <Col md={6}>
                          <div className="d-flex align-items-center">
                            <div className="w-25 mx-2" style={{ cursor: "pointer" }}
                              onClick={() => handleShowImg(item?.image)}

                            >
                              <img src={item.image} alt="" className='w-100 rounded' />


                            </div>
                            <div>
                              <p className="mb-1 fw-bold fs-6">          {item?.title}</p>
                              <p className="mb-1  fs-6">          {item?.description}</p>
                              <p className="mb-1  text-muted">         {item?.updated_at}</p>

                            </div>
                          </div>
                        </Col>
                        <Col md={6}>

                          <div className="d-flex justify-content-end align-items-center h-100">

                            {title == "maintenance" &&
                              <div >
                                {localStorage.getItem("type") != "maintenance" ?
                                  <div className='d-flex'>
                                    <Button className='mx-3'
                                      onClick={() => {
                                        setModalShow(true);
                                        setstatusPending("accept");
                                        setSelectedItem(item);
                                        setSelectedType(title);
                                        setPaymentState('fees')


                                      }}
                                    >{currentLocal.home.accept}</Button>
                                    <Button variant="danger" onClick={() => {
                                      setModalShow(true);
                                      setstatusPending("reject");
                                      setSelectedItem(item);
                                      setSelectedType(title); // <- save which section
                                    }}>{currentLocal.home.reject}</Button>
                                  </div>
                                  :
                                  <div className="form-check" onClick={() => {
                                  }}>

                                  </div>
                                }


                              </div>
                            }
                            {title == "purchase" &&
                              <div >
                                {localStorage.getItem("type") != "purchases" ?

                                  <div className='d-flex'>
                                    <Button className='mx-3'
                                      onClick={() => {
                                        setModalShow(true);
                                        setstatusPending('accept')

                                      }}
                                    >{currentLocal.home.accept}</Button>
                                    <Button variant="danger" onClick={() => {
                                      setModalShow(true);
                                      setstatusPending('reject')
                                    }}>{currentLocal.home.reject}</Button>
                                  </div>
                                  :
                                  <div className="form-check" onClick={() => {
                                    navigate(`/dashboard/maintenances/edite/${item?.id}`)
                                  }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                      <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                    </svg>
                                  </div>}
                                {/* <div className="form-check">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
  <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
</svg>
</div> */}
                                {/* <CustomModel
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            status={statusPending}
                            acceptStatus={"purchases"}
                            id={item?.id}
                          /> */}

                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </div>
                ) : (
                  <p>No data found</p>
                )}
              </div>
            ))}
          </div>
  
        </Row>
      </Container>

      {/* Modal for reject reason */}

    </div>
  );
}

export default Notifications;
